// Dependencies
import React, { Component } from 'react';
import { isMobileOnly } from 'react-device-detect';

// Primereact imports
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

// Multi lang
import { withTranslation } from 'react-multi-lang';

// Styling
import './orders.scss';

// Redux
import { connect } from 'react-redux';
import { getOrderList } from '../../../redux/actions/order';
import FinancialService from '../../../redux/services/finance';

// Utils
import { ORDER_STATE_BALLOT_RETURN, ORDER_STATE_CANCELLED, ORDER_STATE_PAYED, ORDER_STATE_WAITING_PAYMENT, PAYMENT_CHANNEL_CREDIT_CARD, PAYMENT_CHANNEL_MB, PAYMENT_CHANNEL_MBWAY } from '../../../common/constants';

class OrdersListComponent extends Component {

    constructor(props) {
        super(props);
        this._toast = React.createRef();
    }

    componentDidMount() {
        this.props.getOrderList(this.props.associate.associateId);
    }

    transformOrdersDataSource(orders) {;
        let transformedOrders = [];

        for (let i = 0; i < orders.length; i++) {
            
            let products = <div>
            {
                orders[i].products.map((product) => { 
                    return <p>{this.props.t("products.products." + product.title)}</p>;
                })
            }
            </div>;

            transformedOrders.push({
                products: products,
                submitDate: orders[i].submitDate,
                paymentState: orders[i].paymentState,
                paymentDate: orders[i].paymentDate,
                paymentChannel: orders[0].paymentChannel,
                amount: orders[i].amount,
                invoiceRef: orders[i].invoiceRef
            });
        }

        return transformedOrders;
    }

    amountBodyTemplate(rowData) {
        if(rowData.amount === null) {
            return "Gratuito";
        }
        else {
            if(rowData.amount.toString().includes(".")) {
                let amountParts = rowData.amount.toString().split(".");

                if(amountParts[1].length === 1) {
                    return rowData.amount + "0 €";
                }
                else {
                    return rowData.amount + " €";
                }     
            }
            else {
                return rowData.amount + ".00 €";
            }
        }

        return "";
    }

    dateBodyTemplate(rowData, column) {
        if(rowData[column] !== null) {
          return rowData[column] !== undefined ? rowData[column].replace('T',' ') : "";
        }
        else {
          return "";
        }
    }

    stateBodyTemplate(rowData) {
        if(rowData.paymentState === ORDER_STATE_PAYED) {
            return <span className={'state-badge'} style={{background: '#C8E6C9', color: '#256029'}}>{this.props.t("orders.form.payed")}</span>;
        }
        else if(rowData.paymentState === ORDER_STATE_WAITING_PAYMENT) {
            return <span className={'state-badge'} style={{background: '#feffb3', color: '#000000'}}>{this.props.t("orders.form.waiting-payment")}</span>;
        }
        else if(rowData.paymentState === ORDER_STATE_CANCELLED) {
            return <span className={'state-badge'} style={{background: '#b80406', color: '#ffffff'}}>{this.props.t("orders.form.cancelled")}</span>;
        }
    }

    paymentChannelBodyTemplate(rowData) {
        if(rowData.amount === null) {
            return "";
        }

        if(rowData.paymentChannel === PAYMENT_CHANNEL_MB) {
            return this.props.t("orders.form.payment-channel-mb");
        }
        else if(rowData.paymentChannel === PAYMENT_CHANNEL_MBWAY) {
            return this.props.t("orders.form.payment-channel-mbway");
        }
        else if(rowData.paymentChannel === PAYMENT_CHANNEL_CREDIT_CARD) {
            return this.props.t("orders.form.payment-channel-credit-card");
        }
        else {
            return "";
        }
    }

    invoiceDownloadBodyTemplate(rowData) {
        return rowData.paymentState === ORDER_STATE_PAYED ? <Button icon="pi pi-download" onClick={() => this.downloadInvoice(rowData.invoiceRef)} /> : null;
    }

    downloadInvoice(invoiceRef) {
        FinancialService.generateInvoicePdf(invoiceRef)
          .then((response) => {
              window.open(response.output.pdfUrl, '_blank');
          })
          .catch(error => {
              this._toast.current.show({ severity: 'error', detail: this.props.t("orders.messages.error"), life: 3000 });
          });
    }

    render() {

       return (
            <div>
                <div className={isMobileOnly ? 'grid mgb-20' : 'grid mgb-80'}>
                    <div className="col-12">                   
                        <div id="data-container" className="card mgt-20">
                        {
                            this.props.orders !== null ? 
                                <div className="grid">
                                    <div className="col-12">
                                        <DataTable value={this.transformOrdersDataSource(this.props.orders)} className="p-datatable-gridlines" showGridlines rows={12} dataKey="orderRef" responsiveLayout="scroll" emptyMessage={this.props.t("orders.messages.no-orders")}>
                                            <Column field="products" header={this.props.t("orders.form.products-header")} />
                                            <Column field="submitDate" header={this.props.t("orders.form.submit-date-header")} body={(data) => this.dateBodyTemplate(data, 'submitDate')} style={{ minWidth: '12rem' }} />
                                            <Column field="paymentState" header={this.props.t("orders.form.state-header")} body={(data) => this.stateBodyTemplate(data)} style={{ minWidth: '10rem' }}  />
                                            <Column field="paymentDate" header={this.props.t("orders.form.payment-date-header")} body={(data) => this.dateBodyTemplate(data, 'paymentDate')} style={{ minWidth: '12rem' }} />
                                            <Column field="amount" header={this.props.t("orders.form.amount-header")} body={(data) => this.amountBodyTemplate(data)} style={{ minWidth: '8rem' }}  />
                                            <Column field="paymentChannel" header={this.props.t("orders.form.channel-header")} body={(data) => this.paymentChannelBodyTemplate(data)} style={{ minWidth: '12rem' }}  />
                                            <Column field="invoiceRef" header={this.props.t("orders.form.invoice-header")} body={(data) => this.invoiceDownloadBodyTemplate(data)} style={{ minWidth: '8rem' }}  />
                                        </DataTable>
                                    </div>
                                </div>
                                : null
                        }
                        </div>
                    </div>
                </div>
                <Toast position='bottom-left' ref={this._toast} />
            </div>
        );
  }

}

const mapStateToProps = (state) => {
    return {
        associate: state.profile.associate,
        orders: state.store.orders
    } 
};
  
const mapDispatchToProps = (dispatch) => {
    return {
        getOrderList: (associateId) => { dispatch(getOrderList(associateId)) }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(OrdersListComponent));